var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "wintacLoading",
      staticClass: "container",
      staticStyle: { width: "5.36rem" },
      style: { "--color": _vm.themeColor, "--lightColor": _vm.lightThemeColor },
    },
    [
      _vm.datas.seconds && _vm.datas.seconds > 0
        ? _c(
            "div",
            { staticStyle: { display: "flex", "margin-bottom": "0.1rem" } },
            [
              _c("Countdown", {
                attrs: { second: _vm.datas.seconds },
                on: {
                  "countdown-ended": function ($event) {
                    _vm.datas.seconds = null
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c("div", { staticStyle: { display: "flex" } }, [
        _c("div", { staticStyle: { flex: "1" } }, [
          _c(
            "div",
            { staticClass: "titleBox", staticStyle: { width: "5.36rem" } },
            [
              _c(
                "div",
                { staticClass: "btns", on: { click: _vm.scrollToLeft } },
                [_c("i", { staticClass: "el-icon-arrow-left" })]
              ),
              _c(
                "div",
                { ref: "center", staticClass: "center" },
                _vm._l(_vm.datas.statusResultList, function (item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "box",
                      staticStyle: { display: "flex", "align-items": "center" },
                    },
                    [
                      _c("div", { staticClass: "btns1" }, [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                              position: "relative",
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "yuan",
                                class: item.highlight ? "highlight" : "",
                              },
                              [_vm._v(" " + _vm._s(item.serialNumber) + " ")]
                            ),
                            index !== _vm.datas.statusResultList.length - 1
                              ? _c("div", { staticClass: "line" })
                              : _vm._e(),
                          ]
                        ),
                        _c(
                          "p",
                          {
                            staticClass: "p1",
                            class: item.highlight ? "textHighlight" : "",
                          },
                          [_vm._v(_vm._s(item.statusText))]
                        ),
                      ]),
                    ]
                  )
                }),
                0
              ),
              _c(
                "div",
                { staticClass: "btns", on: { click: _vm.scrollToRight } },
                [_c("i", { staticClass: "el-icon-arrow-right" })]
              ),
            ]
          ),
          _c(
            "div",
            { staticClass: "footerBox" },
            [
              _vm._l(_vm.datas.opLogResults, function (item, index) {
                return _c("div", { key: index, staticClass: "footerLine" }, [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "align-items": "center",
                        transform: "scale(0.9)",
                        "transform-origin": "0 0",
                        "white-space": "nowrap",
                      },
                    },
                    [
                      _c("svg-icon", {
                        staticClass: "svg",
                        staticStyle: { "margin-right": "0.08rem" },
                        attrs: { iconClass: "naozhong" },
                      }),
                      _c("p", {
                        staticClass: "p1",
                        class: { isBlod: index === 0 },
                        domProps: { innerHTML: _vm._s(item.remark) },
                      }),
                    ],
                    1
                  ),
                ])
              }),
              _c(
                "div",
                { staticClass: "operatingButton" },
                [
                  _vm._l(_vm.datas.opButtonResultList, function (n) {
                    return _c(
                      "div",
                      { key: n.buttonName },
                      [
                        _vm.dataType == 0 || n.functionName === "viewInquiry"
                          ? _c("DynamicButton", {
                              staticStyle: { "margin-right": "0.1rem" },
                              style: {
                                color: n.buttonColor ? n.buttonColor : "#fff",
                                backgroundColor: n.buttonBackgroundColor
                                  ? n.buttonBackgroundColor
                                  : "#DE562C",
                                borderColor: n.buttonBackgroundColor
                                  ? n.buttonBackgroundColor
                                  : "#DE562C",
                              },
                              attrs: {
                                size: "mini",
                                buttonText: n.buttonName,
                                permFlag: true,
                                perm: "ce",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.update(n.functionName)
                                },
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  }),
                  _vm.isShowModifyPriceBtn()
                    ? _c("DynamicButton", {
                        staticStyle: { "margin-right": "0.1rem" },
                        style: {
                          color: "#fff",
                          backgroundColor: "#DE562C",
                          borderColor: "#DE562C",
                        },
                        attrs: {
                          size: "mini",
                          buttonText: "修改价格",
                          permFlag: true,
                          perm: "ce",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.update("adjustOrderContentAndAmount")
                          },
                        },
                      })
                    : _vm._e(),
                  _vm.allDatas.state === 3 || _vm.allDatas.state === 5
                    ? _c(
                        "el-button",
                        {
                          attrs: { size: "mini", type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.$emit(
                                "handlerSeeConfirm",
                                _vm.allDatas
                              )
                            },
                          },
                        },
                        [_vm._v("查看已确认行程 ")]
                      )
                    : _vm._e(),
                  _vm.dataType === 1
                    ? _c(
                        "el-button",
                        {
                          staticClass: "contactBtn",
                          attrs: { size: "mini", type: "primary" },
                          on: { click: _vm.openChat },
                        },
                        [_vm._v("联系客户")]
                      )
                    : _vm._e(),
                ],
                2
              ),
            ],
            2
          ),
        ]),
      ]),
      _c("remarkPopup", { ref: "remarkPopup" }),
      _c("createPreOrder", { ref: "createPreOrder" }),
      _c("modifyTable", {
        ref: "modifyTable",
        attrs: { tableData: [JSON.parse(JSON.stringify(_vm.allDatas))] },
      }),
      _c("orderChangePopup", {
        ref: "cancelOrderPopup",
        attrs: { childrenIds: [_vm.orderChildrenId], allDatas: _vm.allDatas },
      }),
      _c("orderCancellationPopup", { ref: "orderCancellationPopup" }),
      _c("inquiryDetailsPopup", {
        ref: "inquiryDetailsPopup",
        attrs: { allDatas: _vm.allDatas },
      }),
      _c("static-pay-table", { ref: "staticPayTable" }),
      _c("confirmFeesAndCancelOrders", {
        ref: "confirmFeesAndCancelOrders",
        on: {
          updateList: function ($event) {
            return _vm.$emit("updateList")
          },
        },
      }),
      _c("ChatModal", {
        attrs: {
          show: _vm.showChatModal,
          "user-info": {
            userId: _vm.allDatas.createId,
          },
        },
        on: { close: _vm.closeChatModal },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }